import { ReportType, ApprovalState } from "@fdm/api-client";
import { ReportFormPage } from "../../report-form-control.service";

export const ACTION_ITEM_OWNER_POLICY = {
    [ReportType.AnomalyReport]: {
      [ReportFormPage.ACTION_ITEM]: [
        ApprovalState.Draft,
        ApprovalState.DraftedForReview,
        ApprovalState.SubmittedToOpsAdvisor,
        ApprovalState.PlanConfirmed,
        // ApprovalState.RIPTScored,
        // ApprovalState.RIPTSkipped,
        // ApprovalState.RIPTScoredSkipped,
        ApprovalState.RiskEvaluationScored,
        ApprovalState.PlanEndorsed,
        ApprovalState.PlanApproved,
      ],
      [ReportFormPage.NOTES_ATTACHMENTS]: [
        ApprovalState.Draft,
        ApprovalState.DraftedForReview,
        ApprovalState.SubmittedToOpsAdvisor,
        ApprovalState.PlanConfirmed,
        ApprovalState.RIPTScored,
        ApprovalState.RiskEvaluationScored,
        // ApprovalState.RIPTSkipped,
        ApprovalState.PlanEndorsed,
      ],
    },
    [ReportType.IntegrityDeficiency]: {
      [ReportFormPage.ACTION_ITEM]: [
        ApprovalState.Draft,
        ApprovalState.DraftedForReview,
        ApprovalState.SubmittedToOpsAdvisor,
        ApprovalState.PlanConfirmed,
        ApprovalState.RIPTScored,
        ApprovalState.RiskEvaluationScored,
        // ApprovalState.RIPTSkipped,
        ApprovalState.PlanEndorsed,
        ApprovalState.PlanApproved,
      ],
      [ReportFormPage.NOTES_ATTACHMENTS]: [
        ApprovalState.Draft,
        ApprovalState.DraftedForReview,
        ApprovalState.SubmittedToOpsAdvisor,
        ApprovalState.PlanConfirmed,
        ApprovalState.RIPTScored,
        ApprovalState.RiskEvaluationScored,
        // ApprovalState.RIPTSkipped,
        ApprovalState.PlanEndorsed,
      ],
    },
    [ReportType.IntegrityThreat]: {
      [ReportFormPage.ACTION_ITEM]: [
        ApprovalState.Draft,
        ApprovalState.DraftedForReview,
        ApprovalState.SubmittedToOpsAdvisor,
        ApprovalState.PlanConfirmed,
        ApprovalState.RIPTScored,
        ApprovalState.RiskEvaluationScored,
        // ApprovalState.RIPTSkipped,
        ApprovalState.PlanEndorsed,
        ApprovalState.PlanApproved,
      ],
      [ReportFormPage.NOTES_ATTACHMENTS]: [
        ApprovalState.Draft,
        ApprovalState.DraftedForReview,
        ApprovalState.SubmittedToOpsAdvisor,
        ApprovalState.PlanConfirmed,
        ApprovalState.RIPTScored,
        ApprovalState.RiskEvaluationScored,
        // ApprovalState.RIPTSkipped,
        ApprovalState.PlanEndorsed,
      ],
    },
    [ReportType.TaskDeferral]: {
      [ReportFormPage.ACTION_ITEM]: [
        ApprovalState.Draft,
        ApprovalState.DraftedForReview,
        ApprovalState.SubmittedToOpsAdvisor,
        ApprovalState.PlanConfirmed,
        ApprovalState.RIPTScored,
        ApprovalState.RiskEvaluationScored,
        // ApprovalState.RIPTSkipped,
        ApprovalState.PlanEndorsed,
        ApprovalState.PlanApproved,
      ],
      [ReportFormPage.NOTES_ATTACHMENTS]: [
        ApprovalState.Draft,
        ApprovalState.DraftedForReview,
        ApprovalState.SubmittedToOpsAdvisor,
        ApprovalState.PlanConfirmed,
        ApprovalState.RIPTScored,
        ApprovalState.RiskEvaluationScored,
        // ApprovalState.RIPTSkipped,
        ApprovalState.PlanEndorsed,
      ],
    },
  }